module.exports = __webpack_public_path__ + "static/researching-b1e6edff5d324e394d3da4dbfc18aa82.svg";